<template>
  <el-footer :style="footStyle" :class="{mourningGrey:mourningTime}">
    <div class="footer">
      <p class="footer-p">
        <a href="http://www.people.com.cn/GB/50142/420117/index.html" target="_blank">关于人民网</a>
        <span class="xian">|</span>
        <a href="http://gonggao.people.com.cn/" target="_blank">供稿服务</a>
        <span class="xian">|</span>
        <a href="http://www.people.com.cn/n/2013/1227/c373005-23961344.html" target="_blank">网站声明</a>
        <span class="xian">|</span>
        <a href="http://www.people.com.cn/n1/2019/0308/c420117-30965009.html" target="_blank">网站律师</a>
        <span class="xian">|</span>
        <a href="http://sso.people.com.cn/resource/html/userInforPro.html" target="_blank">信息保护</a>
        <span class="xian">|</span>
        <a href="http://vip.people.com.cn/" target="_blank">人民图片</a>
      </p>
      <div class="content">
        <p>
          <a
            href="http://www.people.com.cn/img/2014xuke/2018hlwxw.html"
            target="_blank"
          >互联网新闻信息服务许可证10120170001</a>
          <span class="xian">|</span>
          <a
            href="http://www.people.com.cn/img/2014xuke/2018zzdxxkz.html"
            target="_blank"
          >增值电信业务经营许可证B1-20060139</a>
        </p>
        <p>
          <a
            href="http://www.people.com.cn/img/2019peopleindex/html/gbds2019.html"
            target="_blank"
          >广播电视节目制作经营许可证（广媒）字第172号</a>
          <span class="xian">|</span>
          <a
            href="http://www.people.com.cn/img/2014xuke/2019ypxxfwzg.html"
            target="_blank"
          >互联网药品信息服务资格证书（京）-非经营性-2016-0098</a>
        </p>
        <p>
          <a
            href="http://www.people.com.cn/img/2011zzzs/2018xxwlcb.htm"
            target="_blank"
          >信息网络传播视听节目许可证0104065</a>
          <span class="xian">|</span>
          <a
            href="http://www.people.com.cn/img/2014xuke/2018wlwh.html"
            target="_blank"
          >网络文化经营许可证 京网文[2017]9786-1126号</a>
          <span class="xian">|</span>
          <a
            href="http://www.people.com.cn/img/2014xuke/2018wlcb.html"
            target="_blank"
          >网络出版服务许可证（京）字258号</a>
          <span class="xian">|</span>
          <a href="http://www.people.com.cn/img/2014xuke/2018icp.html" target="_blank">京ICP证000006号</a>
          <span class="xian">|</span>
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000008"
            target="_blank"
          >京公网安备11000002000008号</a>
        </p>
        <p>人民网版权所有，未经书面授权禁止使用</p>
        <p>Copyright © 1997-2020 by www.people.com.cn. all rights reserved</p>
        <p style="margin-top:40px;">
          <a href="http://www.hd315.gov.cn/beian/view.asp?bianhao=0102000101300040" target="_blank">
            <img src="../../static/images/icon/copy_icon1.jpg" />
          </a>
          <a
            href="https://ss.knet.cn/verifyseal.dll?sn=e12050911010020686307708&ct=df&a=1&pa=980951"
            target="_blank"
          >
            <img src="../../static/images/icon/copy_icon2.jpg" />
          </a>
          <a href="http://si.trustutn.org/info?sn=470170320027574551118&certType=1" target="_blank">
            <img src="../../static/images/icon/copy_icon3.jpg" />
          </a>
          <a
            href="http://www.itrust.org.cn/home/index/itrust_certifi/wm/2710933198.html"
            target="_blank"
          >
            <img src="../../static/images/icon/copy_icon4.jpg" />
          </a>
        </p>
      </div>
    </div>
  </el-footer>
</template>
<script>
import dateJudge from "../utils/dateJudge";

export default {
  name: "peopleFooter",
  data() {
    return {
      footStyle:
        document.body.clientWidth > 750
          ? "background: #fff;padding: 0 !important;height: 400px;border-bottom: 10px solid #e9450a;"
          : "background: #fff;padding: 0 !important;width:100%;height: 40rem;border-bottom: 10px solid #e9450a;"
    };
  },
  mounted() {},
  computed: {
    mourningTime() {
      return dateJudge.isDuringDate(
        "2020/04/04 00:00:00",
        "2020/04/04 23:59:59"
      );
    }
  }
};
</script>

<style lang="less" scoped>
.mourningGrey {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
.footer {
  background: #fff;
  color: #080808;
  width: 100%;
  height: 380px;
  margin: 0px auto;
  text-align: center;
  .footer-p {
    padding: 50px 0 10px 0;
    text-align: center;
    @media screen and (max-width: 750px) {
      padding: 2rem 0 2rem 0;
    }
    a {
      @media screen and (max-width: 750px) {
        font-size: 1rem;
        padding: 0 0.55rem;
        color: #080808;
      }
      color: rgba(102, 102, 102, 1);
    }
  }
  .content {
    text-align: center;
    height: 150px;
    @media screen and (max-width: 750px) {
      text-align: left;
      width: 100%;
      padding: 0 0.8rem;
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 30px;
      a {
        color: rgba(102, 102, 102, 1);
      }
    }
    .mt30 {
      margin: 40px 0px;

      a {
        margin: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/peopleFooter.vue